import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkTopAccordion from "../../components/molecules/TkTopAccordion";
import TkProcedureTable from "../../components/molecules/TkProcedureTable";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { httpAPI_APP002, httpAPI_APP017 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { HandleButton, ProcedureModal, TopInfo } from "./components/components";
import SCRC090002 from "../SCRC090002";
import {
  IAPI_APP017_Response,
  LatestProcedureInfoList,
  ProcedureInfoList,
} from "../../type/apiType/IAPI_APP017";
import { navigatePath } from "./hooks/useHooks";
import { BusinessContext } from "../../context/businessContext";

/**
 * SCRD310001 代行者ホーム
 * @return SCRD310001 代行者ホーム
 */
const SCRD310001 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);
  const [res, setRes] = useState<IAPI_APP017_Response>({});
  // 対応が必要な手続き
  const [procedureList, setProcedureList] = useState<any>([]);
  // 最近の手続き履歴
  const [procedureHistoryList, setProcedureHistoryList] = useState<any>([]);
  // 手続きのお知らせモーダルの開閉状態
  const [openModalState, setOpenModalState] = useState<boolean>(false);
  // モーダル内のボタン
  const [modalButton, setModalButton] = useState<any>(<></>);
  const [modalItem, setModalItem] = useState({});
  // スレッドモーダルを開閉
  const [openThread, setOpenThread] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期表示
  const handleInit = async () => {
    // 法人ホーム表示APIを呼び出す
    try {
      const res = await httpAPI_APP017({
        userId: state.authInfo?.userId!,
      });
      if (res.resultCd === "I0000") {
        setRes(res);
        setIsExpanded(!!res.notificationInfoList?.length);

        if (location.state?.cancelRequestFlg === "1") {
          setState({
            ...state,
            errorMsgId: "TKMSG_SCR0004I",
          });
        } else {
          setState({
            ...state,
            errorMsgId: "",
          });
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const handleCallApi = async (button: any, data: any) => {
    let eventNum;
    switch (button) {
      case "確認":
        eventNum = "3";
        break;
      case "不要":
        eventNum = "1";
        break;
      case "取下":
        eventNum = "4";
        break;
      case "戻す":
        eventNum = "0";
        break;
      case "削除":
        eventNum = "5";
        break;
    }

    try {
      const res = await httpAPI_APP002({
        taskId: data.taskId,
        contractorNo: state.authInfo?.contractorNo,
        event: eventNum,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        location.state?.cancelRequestFlg &&
          (location.state.cancelRequestFlg = null);
        handleInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleNavigate = (item: any) => {
    setBusinessState({
      common: { businessType: item?.businessType },
    });

    navigate(navigatePath(item?.businessType), {
      state: { taskId: item?.taskId, applyId: item?.applyId },
    });
  };

  // ボタン押下時
  const handleButtonClick = (name: any, item: any, isHistory: any) => {
    setBusinessState({
      common: { businessType: item?.businessType },
    });

    switch (name) {
      case "手続きへ":
        // 持回り情報の設定（手続き情報リスト.タスクid）
        // 依頼内容処理状況管理（SCR0096_1）画面に遷移する。
        navigate("/SCRD310002", {
          state: { taskId: item?.taskId, applyId: item?.applyId },
        });
        break;
      case "確認":
        isHistory
          ? //依頼内容処理状況管理（SCR0096_1）画面に遷移する&持回り情報で、タスクidを設定する
            handleNavigate(item)
          : handleCallApi(name, item);
        break;
      default:
        handleCallApi(name, item);
        break;
    }
  };

  // リンク押下時
  const handleLinkClick = async (item: any, button: any) => {
    if (item?.threadId) {
      navigate(".", {
        state: {
          ...location.state,
          threadId: item?.threadId,
        },
        replace: true,
      });
      // スレッドモーダルopen
      setOpenThread(true);
    } else {
      // 法人ホーム表示APIで設定された内容のモーダルを開く。
      setModalButton(button);
      setModalItem(item);
      setOpenModalState(true);
    }
  };

  // 画面描画
  useEffect(() => {
    let procedureList = res.procedureInfoList?.map(
      (item: ProcedureInfoList) => {
        const button = (
          <HandleButton
            item={item}
            isHistory={false}
            onClick={(e: any) => handleButtonClick(e, item, false)}
          />
        );

        return {
          important: item.importantFlg === "1",
          progress: item.latestApplyStatusName,
          date: item.dueDate,
          procedureName: item.businessTypeShortName,
          message: (
            <Link to="" onClick={() => handleLinkClick(item, button)}>
              {item.procedureTitle}
            </Link>
          ),
          timing: item.executionName ?? "-",
          children: button,
        };
      }
    );

    setProcedureList(procedureList);

    let procedureHistoryList = res.latestProcedureInfoList?.map(
      (item: LatestProcedureInfoList) => {
        return {
          important: item.importantFlg === "1",
          progress: item.latestApplyStatusName,
          date: item.dueDate,
          procedureName: item.businessTypeShortName,
          message: item.procedureTitle,
          timing: item.executionName ?? "-",
          children: (
            <HandleButton
              item={item}
              isHistory={true}
              onClick={(e: any) => handleButtonClick(e, item, true)}
            />
          ),
        };
      }
    );

    setProcedureHistoryList(procedureHistoryList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [res]);

  return (
    <Box className="SCRD310001" data-testid="SCRD310001PageForTest">
      <TopInfo item={res} />
      <TkTopAccordion
        notifications={res.notificationInfoList}
        expanded={isExpanded}
        onChange={() => setIsExpanded(!isExpanded)}
      />

      <TkProcedureTable procedureList={procedureList} maxHeight={400} />

      <TkProcedureTable
        procedureList={procedureHistoryList}
        title="最近の手続き履歴"
        historyLink="/SCRD310003"
        maxHeight={400}
        titleChangeToUpdateDay
      />

      <ProcedureModal
        open={openModalState}
        button={modalButton}
        item={modalItem}
        onClose={() => setOpenModalState(false)}
      />

      <SCRC090002
        threadId={location.state?.threadId}
        open={openThread}
        onClose={() => setOpenThread(false)}
      />
    </Box>
  );
};

export default SCRD310001;
